import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 inline-block">
          <Logo className="h-9" />
        </Link>
        {sent ? (
          <div className="rounded-2xl border border-border bg-card p-8 text-center">
            <MailCheck className="mx-auto h-12 w-12 text-accent" />
            <h1 className="mt-4 font-heading text-2xl font-bold">Check your inbox</h1>
            <p className="mt-2 text-muted-foreground">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight">Reset password</h1>
            <p className="mt-2 text-muted-foreground">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              {error && <p className="text-sm text-destructive">{error}</p>}
              <Button type="submit" className="w-full" data-testid="forgot-submit" disabled={loading}>
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
